export default "__VITE_ASSET__55oS2XpP__"